import { render, staticRenderFns } from "./ResetPass.vue?vue&type=template&id=3b9cd419&scoped=true"
import script from "./ResetPass.vue?vue&type=script&lang=js"
export * from "./ResetPass.vue?vue&type=script&lang=js"
import style0 from "./ResetPass.vue?vue&type=style&index=0&id=3b9cd419&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9cd419",
  null
  
)

export default component.exports